import React, { useMemo, useState, useNavigate } from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column, InputText, Dialog, FileUpload, InputTextarea, Toast, RadioButton } from "primereact";
import QRCode from "react-qr-code";
import { Formik, useFormikContext } from "formik";
import * as Yup from "yup";

import "../../assets/css/badge.css";

class ListaAnnata extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      caratteristica: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.prodottoid = 0;
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    this.prodottoid = this.props.prodottoid;
    this.caricaDati(1, this.state.pageSize);
    this.stato = this.props.stato;
    if (this.stato == "U") {
      this.actions.push(
        {
          id: 2,
          icon: "pi-pencil",
          label: "",
          action: (id) => {
            this.vai(id, "U");
            console.log("Update " + id);
          },
        },
        {
          id: 3,
          icon: "pi-trash",
          label: "",
          action: (id) => {
            this.vai(id, "D");
            console.log("Delete " + id);
          },
        },
      );
    }
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&prodottoid=" + this.prodottoid;
    axios
      .get(Costanti.UrlCallApi + "allergeni/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        this.setState({ caratteristica: res.data.lista1, totalRecords: res.data.conta1, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "allergeni/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  salva(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });

    if (this.state.tipo == "D") {
      values.status = "E";
      axios
        .post(Costanti.UrlCallApi + "allergeni/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "U") {
      axios
        .post(Costanti.UrlCallApi + "allergeni/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "A") {
      var dato = {
        datains: null,
        dataupd: null,
        id: 0,
        nome: values.nome,
        descrizione: values.descrizione,
        nomeen: values.nomeen,
        descrizioneen: values.descrizioneen,
        prodottoid: this.prodottoid,
        uteins: 1,
        uteupd: null,
        valore: values.valore,
        tipo: values.tipo,
        status: " ",
      };
      axios
        .post(Costanti.UrlCallApi + "allergeni/aggiungi", dato, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }

    setTimeout(() => this.setVisible1(false), 1000);
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Annata" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Annata" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Annata" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Annata" });
        break;
    }
  }
  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/allergeni/" + this.prodottoid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

    
        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <DataTable
          value={this.state.caratteristica}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Annata</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
         
              {/*<Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="p-button-rounded p-button-danger "/> */}
              <Button
                label="Aggiungi"
                onClick={() => this.vai(0, "A")}
                icon="pi pi-plus"
                className="p-button-rounded p-button-primary "
              />
            </div>
          }
          responsiveLayout="stack"
        >
          <Column id="id1" field="nome" header="Nome" />
          <Column id="id1" field="descrizione" header="Descrizione" />
          <Column id="id1" field="nomeen" header="Name" />
          <Column id="id1" field="descrizioneen" header="Description" />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        <Dialog
          header={this.state.intestazione}
          closable={false}
          visible={this.state.visible1}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <Formik
                initialValues={{
                  nome: this.state.singolo.nome,
                  descrizione: this.state.singolo.descrizione,
                  nomeen: this.state.singolo.nomeen,
                  descrizioneen: this.state.singolo.descrizioneen,
                  tipo: this.state.singolo.tipo,
                  status: this.state.singolo.status,
                }}
                enableReinitialize
                validationSchema={this.validationSchema}
                onSubmit={(values) => {
                  this.salva(values);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="grid formgrid p-fluid">
                      <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="nome" className="font-medium text-600">
                          <img src="images/flag_placeholder.png" className="flag flag-it" />
                          Nome
                        </label>
                        <InputText
                          name="nome"
                          readOnly={!this.state.editMode}
                          value={values.nome}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="descrizione" className="font-medium text-600">
                          <img src="images/flag_placeholder.png" className="flag flag-it" />
                          Descrizione
                        </label>
                        <InputText
                          name="descrizione"
                          readOnly={!this.state.editMode}
                          value={values.descrizione}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="nome" className="font-medium text-600">
                          <img src="images/flag_placeholder.png" className="flag flag-uk" />
                          Name
                        </label>
                        <InputText
                          name="nomeen"
                          readOnly={!this.state.editMode}
                          value={values.nomeen}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="descrizione" className="font-medium text-600">
                          <img src="images/flag_placeholder.png" className="flag flag-uk" />
                          Description
                        </label>
                        <InputText
                          name="descrizioneen"
                          readOnly={!this.state.editMode}
                          value={values.descrizioneen}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>

                      <div className="field mb-1 col-12 md:col-12">
                        <RadioButton
                          name="tipo"
                          readOnly={!this.state.editMode}
                          value="1"
                          checked={values.tipo === 1}
                          onChange={() => setFieldValue("tipo", 1)}
                        />
                        <label htmlFor="descrizione" className="font-medium text-600">
                          Prodotto
                        </label>
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <RadioButton
                          name="tipo"
                          readOnly={!this.state.editMode}
                          value="2"
                          checked={values.tipo === 2}
                          onChange={() => setFieldValue("tipo", 2)}
                        />
                        <label htmlFor="descrizione" className="font-medium text-600">
                          Magazzino
                        </label>
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <RadioButton
                          name="tipo"
                          readOnly={!this.state.editMode}
                          value="3"
                          checked={values.tipo === 3}
                          onChange={() => setFieldValue("tipo", 3)}
                        />
                        <label htmlFor="descrizione" className="font-medium text-600">
                          Rischio Contaminazione
                        </label>
                      </div>
                    </div>
                    <footer>
                      <div className="border-top-1 surface-border pt-3">
                        <Button type="submit" visible={this.state.tipo == "U"} icon="pi pi-save" label="Salva" />
                        <Button visible={this.state.tipo == "A"} icon="pi pi-save" label="Aggiungi" />
                        <Button
                          type="submit"
                          visible={this.state.tipo == "D"}
                          icon="pi pi-save"
                          label="Elimina"
                        />
                        <Button
                          type="button"
                          icon="pi pi-check"
                          onClick={() => this.setVisible1(false)}
                          label="Chiudi"
                        />
                      </div>
                    </footer>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaAnnata;
